// extracted by mini-css-extract-plugin
export default {"container":"Ui-z","bubbleNav":"Vi-z","graphic":"Wi-z","contact":"Xi-z"};